/**
 * @generated SignedSource<<2c2b517b6e63f7e99180a1e467b12d23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sourcesPage_CancelMutation$variables = Record<PropertyKey, never>;
export type sourcesPage_CancelMutation$data = {
  readonly qboSyncCancel: {
    readonly cancelled: number;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type sourcesPage_CancelMutation = {
  response: sourcesPage_CancelMutation$data;
  variables: sourcesPage_CancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelled",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "sourcesPage_CancelMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QboSyncCancelMutationPayload",
        "kind": "LinkedField",
        "name": "qboSyncCancel",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "sourcesPage_CancelMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QboSyncCancelMutationPayload",
        "kind": "LinkedField",
        "name": "qboSyncCancel",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "26fbe973323707334be5c29f864f77f4",
    "id": null,
    "metadata": {},
    "name": "sourcesPage_CancelMutation",
    "operationKind": "mutation",
    "text": "mutation sourcesPage_CancelMutation {\n  qboSyncCancel {\n    cancelled\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52e26b611e3bfbb18a54b12af2c6463b";

export default node;
